import { render, staticRenderFns } from "./ExamFreedomDo.vue?vue&type=template&id=0d9f6fca"
import script from "./ExamFreedomDo.vue?vue&type=script&lang=js"
export * from "./ExamFreedomDo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports